<template>
<div v-bind:style="{'display': display ? '' : 'none'}">
  <div class="modal-header">
    <h4 class="header-title">予約削除</h4>
  </div>
  <div class="modal-body">
    予約を削除しますか？
  </div>
  <div class="modal-footer">
    <button class="btn btn-default" @click="back">戻る</button>
    <button class="btn btn-danger" @click="waitFor(remove())">削除</button>
  </div>
</div>
</template>


<script lang="babel">
export default {
  name: 'reservation-table-modal-form-remove',
  props: {
    display: {
      type: Boolean,
      default: true,
    },
    shop: {
      type: Object,
      required: true,
    },
  },
  events: {
    'prepare-create': function (createAt) {
      this.reservation = null
    },
    'prepare-update': function (reservation) {
      this.reservation = Object.assign({}, reservation)
    },
  },
  data() {
    return {
      reservation: null
    }
  },
  methods: {
    back() {
      this.$dispatch('switch-modal', 'edit')
    },
    remove() {
      return this.apiPut(
          `/api/1.0/reservations/${this.reservation.pk}/`,
          {isRemoved: true},
          {shopAs: this.shop.pk}
      ).then(response => {
        this.$dispatch('reservation-updated', response.body.data)
      })
    },
  },
  mixins: [
    require('mixin/api-client.vue'),
    require('mixin/wait.vue'),
  ],
}
</script>



// WEBPACK FOOTER //
// remove.vue?1340d463